








import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import ActionShowButton from '@/modules/shared/components/shared/table/action/ActionShowButton.vue'
import {
  DepositCollectionModelInAdmin,
  DepositCollectionWithModelInAdmin
} from '@/modules/deposit/models/deposit-collection.model'
import { AdminTransactionRoute } from '@/modules/transaction/routes/admin.transaction.route'

@Component({
  components: {
    BaseButton,
    ActionShowButton
  }
})
export default class AdminTransactionActions extends Vue {

  constructor(
    private readonly routes: AdminTransactionRoute
  ) {
    super()
  }

  @Prop() transaction!: DepositCollectionModelInAdmin
  @Prop() withData!: DepositCollectionWithModelInAdmin

}

